export const base_url = "https://mcpfastapi-app-oqsge.ondigitalocean.app";
